const notificationState = {
    notifications:[]
}

export default notificationState